import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SharedStore } from '@shared/store/shared.signal-store';
import { waitToResolveSignal } from '@shared/utils/waitToResolve';
import { map, of } from 'rxjs';

export const changePasswordGuard: CanActivateFn = () => {
  const sharedStore = inject(SharedStore);
  const router = inject(Router);

  const cached = sharedStore.currentUser();
  if (!cached) {
    sharedStore.loadCurrentUser();
  }

  const user$ = cached
    ? of(cached)
    : waitToResolveSignal(sharedStore.currentUserLoaded).pipe(map(() => sharedStore.currentUser()));

  return user$.pipe(map(user => !user?.ssoOnly || router.createUrlTree(['/'])));
};
